<ion-header>
  <ion-toolbar>
    <ion-title>Método de pago</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice-transportec/wallet/balance" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-card (click)="pay('credit_card_paycode')" *ngIf="vendorsStore.isPayCodeActive()">
    <img src="assets/imgs/creditcard.jpg" />
    <p>PayCode</p>
  </ion-card>
  <ion-card (click)="pay('credit_card')" *ngIf="vendorsStore.isConektaActive()">
    <img src="assets/imgs/creditcard.jpg" />
    <p>Conekta</p>
  </ion-card>
  <ion-card (click)="pay('credit_card_openpay')" *ngIf="vendorsStore.isOpenPayActive()">
    <img src="assets/imgs/creditcard.jpg" />
    <p>OpenPay</p>
  </ion-card>
  <ion-card *ngIf="vendorsStore.paypalKey() && amount" class="ion-padding">
    <app-payment-paypal
      [clientId]="vendorsStore.paypalKey()!"
      [amount]="amount"
      (paymentSuccess)="onPayPalSuccess($event)"
      (error)="onPayPalError($event)"
    ></app-payment-paypal>
    <p>PayPal</p>
  </ion-card>
  <ion-card (click)="pay('oxxo')" *ngIf="vendorsStore.isOxxoActive()">
    <img src="assets/imgs/oxxo.jpg" />
  </ion-card>
  <ion-card (click)="pay('spei')" *ngIf="vendorsStore.isConektaActive()">
    <img src="assets/imgs/spei.jpg" />
  </ion-card>
</ion-content>

<ion-footer *ngIf="amount">
  <ion-toolbar class="ion-padding">
    <ion-text>A pagar: ${{amount | number}}</ion-text>
  </ion-toolbar>
</ion-footer>
